module.exports = __webpack_public_path__ + "static/media/imagemZebra.a8361d8b.svg";